import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { TASK_CATEGORY } from "../apiRoutes";

interface TaskCategoryResponse {
  data: any;
}

const fetchTaskCategoryDetail = async (id: string) => {
  const response = await axiosAuth.get<TaskCategoryResponse>(
    `${TASK_CATEGORY}${id}`
  );
  return response.data;
};

const useGetTaskCategoryDetailQuery = (
  id?: string,
  queryParams?: UseQueryOptions<any, Error, any, ["taskCategoryDetail", string | undefined]>
) =>
  useQuery<any, Error, any, ["taskCategoryDetail", string | undefined]>({
    queryKey: ["taskCategoryDetail", id],
    queryFn: () => fetchTaskCategoryDetail(String(id)),
    enabled: Boolean(id),
    ...(queryParams as any),
  });

export default useGetTaskCategoryDetailQuery;


